<div class="container">
  <p>Logout complete. You will be redirected in 5 seconds.</p>
</div>
